// Keep native document scrolling (anchors, sticky headers and browser restoration).
export function installPageScrollbar() {
  const root = document.documentElement
  let timer
  let nearEdge = false
  const hideLater = () => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      if (!nearEdge) root.classList.remove('page-scroll-active')
    }, 900)
  }
  const reveal = () => {
    root.classList.add('page-scroll-active')
    hideLater()
  }
  const pointerMove = event => {
    // Native scrollbar side can depend on browser/RTL; support either edge.
    nearEdge = event.clientX <= 16 || event.clientX >= window.innerWidth - 16
    if (nearEdge) reveal()
    else hideLater()
  }
  const pointerLeave = () => { nearEdge = false; hideLater() }
  root.classList.add('admin-page-scroll')
  window.addEventListener('scroll', reveal, { passive: true })
  document.addEventListener('pointermove', pointerMove, { passive: true })
  document.addEventListener('pointerleave', pointerLeave)
  return () => {
    clearTimeout(timer)
    window.removeEventListener('scroll', reveal)
    document.removeEventListener('pointermove', pointerMove)
    document.removeEventListener('pointerleave', pointerLeave)
    root.classList.remove('admin-page-scroll', 'page-scroll-active')
  }
}
